 
export const maskTel = (str,show_length = 4) => {  
  var _str = str + ""
  var str_ln = _str.length
  var res = ""
  var end_loop = str.length - show_length
  for (let index = 0; index < end_loop; index++) {
    res += "X"
  }
  res += _str.slice(end_loop)
  return res
}